import moment from "moment-timezone";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import store from "../store";

toast.configure();
/*******************
@Purpose : Store Data To local Storage
@Parameter : key, value
@Author : INIC
******************/
export const setItem = (key, value) => {
  localStorage.setItem(key, value);
};

/******************* 
    @Purpose : Get Data From local Storage
    @Parameter : key
    @Author : INIC
    ******************/
export const getItem = (key) => {
  return localStorage.getItem(key);
};
/******************* 
    @Purpose : Remove Data From local Storage
    @Parameter : key
    @Author : INIC
    ******************/
export const removeItem = (key) => {
  return localStorage.removeItem(key);
};

export const Authorization = () => {
  return getItem("isLoggedIn") ? true : false;
};

/******************* 
@Purpose : Used to show error toast messages
@Parameter : message
@Author : INIC
******************/
export const showErrorToast = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 1800,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progressClassName: "alert-bar",
  });
};

/******************* 
@Purpose : Used to show sucess toast messages
@Parameter : message
@Author : INIC
******************/
export const showSuccessToast = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 1800,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progressClassName: "alert-bar",
  });
};
/******************* 
@Purpose : Used to show OTP toast 
@Parameter : message
@Author : INIC
******************/
export const showOtpToast = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 6000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progressClassName: "alert-bar",
  });
};

let user = getItem("User");
let users = store.getState();

export const getEncryptedItem = (key, permissionKey) => {
  try {
    let user = store.getState();
    if (key === "Role") {
      return user?.login?.loginEncryptedData.role;
    }
  } catch (error) {}
};

/*******************
@purpose : Used for timeago date format
@Parameter : {dateObj, format, timezone}
@Author : INIC
*******************/
export function timeAgo(
  dateObj = new Date(),
  timezone = moment.tz.guess() || "Asia/Riyadh"
) {
  let finalDate = moment.tz(dateObj, timezone).fromNow();
  if (finalDate === "Invalid date") return null;
  return finalDate;
}

/*******************
@purpose : Used for profile Details data
@Parameter : {data}
@Author : INIC
*******************/
export function profileDataValidation(data) {
  if (data !== "" && data !== undefined) {
    return data;
  } else {
    return "- -";
  }
}

/******************* 
@Purpose : Used to show error toast on greater size 
@Parameter : message
@Author : INIC
******************/
export const fileSizeValidation = (file) => {
  showErrorToast("Please upload file less than 5 MB");
};

/******************* 
@Purpose : Used to show error toast for valid type
@Parameter : message
@Author : INIC
******************/
export const fileTypeValidation = (file) => {
  showErrorToast(file);
};

/******************* 
  @Purpose : use for handling on image error 
  @Parameter :(e,type,name)
  @Author : INIC
  ******************/
export const onImageError = (e, type, name) => {
  e.target.onerror = null;
  if (type === "initials") {
    e.currentTarget.parentNode.children[0].srcset = createImageFromInitials(
      500,
      name,
      "#FFFFFF"
    );
  } else {
    e.currentTarget.parentNode.children[0].srcset =
      "/assets/images/user-no-img.jpg";
  }
};
export const createImageFromInitials = (size, name, color) => {
  if (name == null) return;
  name = getInitials(name);

  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  canvas.width = canvas.height = size;

  context.fillStyle = "#133FF1";
  context.fillRect(0, 0, size, size);

  context.fillStyle = `${color}50`;
  context.fillRect(0, 0, size, size);

  context.fillStyle = color;
  context.textBaseline = "middle";
  context.textAlign = "center";
  context.font = `${size / 2}px Roboto`;
  context.fillText(name, size / 2, size / 2);

  return canvas.toDataURL();
};
const getInitials = (name) => {
  let initials;
  const nameSplit = name.split(" ");
  const nameLength = nameSplit.length;
  if (nameLength > 1) {
    initials =
      nameSplit[0].substring(0, 1) + nameSplit[nameLength - 1].substring(0, 1);
  } else if (nameLength === 1) {
    initials = nameSplit[0].substring(0, 1);
  } else return;

  return initials.toUpperCase();
};

export const validateName = (name) => {
  const pattern = new RegExp(/^[a-z A-Z!@#$%\^&*)(+=._-]*$/);
  return pattern.test(name);
};

export const validateEmail = (emailId) => {
  var pattern = new RegExp(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return pattern.test(emailId);
};

export const validateMobile = (mobile) => {
  const pattern = new RegExp("^[0-9]{10,13}$");

  return pattern.test(mobile);
};

export const validatePhone = (mobile) => {
  const pattern = new RegExp("^[0-9]{8,11}$");

  return pattern.test(mobile);
};
